import { dataAPI } from "../api"
import { IAttachment } from "../../components/resources"
import { AttachmentResourceDTO } from "../models/resources"
import { ODataGetResourceResponse } from "../models/api/data"

export const getAttachment = (id: number): Promise<IAttachment> =>
    dataAPI
        .getJSON<ODataGetResourceResponse<AttachmentResourceDTO>>(
            `attachments(${id})`,
        )
        .then((Attachment) => {
            if (!Attachment.Id) {
                throw new Error("The attachment has no ID.")
            }
            if (!Attachment.FileName) {
                throw new Error("The attachment has no FileName.")
            }
            if (!Attachment.FileSize) {
                throw new Error("The attachment has no FileSize.")
            }
            const newAttachment: IAttachment = {
                id: Attachment.Id,
                filename: Attachment.FileName,
                fileSize: Attachment.FileSize,
                doesExist: true,
            }

            return newAttachment
        })
